import { ProfileSectionsWebSkeleton } from '../../../types/profileWeb';

const Ranking: ProfileSectionsWebSkeleton = {
  projects: 2,
  gallery: 3,
  publications: 1,
};

export default Ranking;
